import React from "react";
import { Alerta, TipoAlerta, Form, CampoTexto, Botao, TipoBotao } from "@intechprev/componentes-web";

import { PageClean } from "..";
import { UsuarioService, FuncionarioService } from "../../services";
import { LoginEntidade } from "../../entidades";
import { reCAPTCHA } from "../../helpers";

interface Props {
  history?: any;
}

interface State {
  user: LoginEntidade;
  nomeUsuario: string;
  senhaNova: string;
  confirmarSenha: string;
  tipoInputSenhaNova: string;
  iconeBotaoSenhaNova: string;
  tituloBotaoSenhaNova: string;
  tipoInputSenhaConfirmar: string;
  iconeBotaoSenhaConfirmar: string;
  tituloBotaoSenhaConfirmar: string;
}

export class TrocarSenhaPrimeiroAcesso extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("primeiro_acesso");

  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      user: new LoginEntidade(),
      nomeUsuario: "",
      senhaNova: "",
      confirmarSenha: "",
      tipoInputSenhaNova: "password",
      iconeBotaoSenhaNova: "fas fa-eye",
      tituloBotaoSenhaNova: "Mostrar Senha",
      tipoInputSenhaConfirmar: "password",
      iconeBotaoSenhaConfirmar: "fas fa-eye",
      tituloBotaoSenhaConfirmar: "Mostrar Senha"
    }
  }

  componentDidMount = async () => {
    try {
      const dados = await FuncionarioService.Buscar();
      const nomeUsuario = dados.DadosPessoais.NOME_ENTID;

      await this.setState({
        nomeUsuario
      });
    }
    catch (err) {
      console.log(err);
    }
  }

  trocarSenha = async () => {
    // Define os estados iniciais de alertas.
    await this.alert.current.limparErros();
    await this.form.current.validar();

    // Valida se a nova senha tem 6 ou mais caracteres.
    if (this.state.senhaNova.length < 6)
      this.alert.current.adicionarErro("A senha deve conter pelo menos 6 caracteres, um número (0-9), uma letra minúscula e maiúscula (a-z, A-Z) e um caracter especial.");

    // Valida se os campos de nova senha e confirmação são iguais.
    if (this.state.senhaNova !== this.state.confirmarSenha)
      this.alert.current.adicionarErro("As senhas não coincidem.");

    try {
      if (this.alert.current.state.mensagem.length === 0 && this.alert.current.props.mensagem.length === 0) {
        let tempUser = this.state.user;
        tempUser.SenhaNova = this.state.senhaNova;
        tempUser.ConfirmarSenha = this.state.confirmarSenha;
        await this.setState({ user: tempUser });

        await UsuarioService.AlterarSenhaPrimeiroAcesso(this.state.user);
        await alert("Senha alterada com sucesso!");
        await this.props.history.push('/');
      }
    } catch (err) {
      if (err.response)
        this.alert.current.adicionarErro(err.response.data)
      else
        console.error(err);
    }
  }

  alternarSenhaVisivelNova = () => {
    const senhaVisivel = this.state.tipoInputSenhaNova === "password";
    this.setState({
      tipoInputSenhaNova: senhaVisivel ? "text" : "password",
      iconeBotaoSenhaNova: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenhaNova: senhaVisivel ? "Esconder Senha" : "Mostrar Senha"
    })
  }

  alternarSenhaVisivelConfirmar = () => {
    const senhaVisivel = this.state.tipoInputSenhaConfirmar === "password";
    this.setState({
      tipoInputSenhaConfirmar: senhaVisivel ? "text" : "password",
      iconeBotaoSenhaConfirmar: senhaVisivel ? "fas fa-eye-slash" : "fas fa-eye",
      tituloBotaoSenhaConfirmar: senhaVisivel ? "Esconder Senha" : "Mostrar Senha"
    })
  }

  render() {
    return (
      <PageClean tamanho={550} {...this.props}>
        {"Olá"}{this.state.nomeUsuario !== "" && <>{`, ${this.state.nomeUsuario},`}</>}<br />
        <br />
        {"Seja bem-vindo!"}<br />
        <br />
        <h3>
          {"Esse é o seu primeiro acesso ao Portal da PREVIRB! Como você recebeu o código gerado automaticamente, ou acessou utilizando a sua última senha cadastrada, será necessário que você crie uma nova senha."}
        </h3>
        <br />
        <br />
        <div className={"alert alert-danger"}>
          <b>{"A senha não pode conter parte do nome ou da data de nascimento."}</b>
          <br />
          <br />
          <b>{"Ela deve conter pelo menos 6 caracteres, um número (0-9), uma letra minúscula (a-z), uma letra maiúscula (A-Z) e um caráter especial (@, #, $, %, *, por exemplo)"}</b>
        </div>
        {/* <Alerta mensagem={"A senha deve conter pelo menos 6 caracteres, um número (0-9), uma letra minúscula (a-z), uma letra maiúscula (A-Z)  e um caráter especial (@, #, $, %, *, por exemplo)."} tipo={TipoAlerta.danger} /> */}

        <Form ref={this.form}>
          <CampoTexto
            contexto={this}
            tipo={this.state.tipoInputSenhaNova}
            nome={"senhaNova"}
            titulo={"Nova Senha"}
            valor={this.state.senhaNova}
            tamanhoTitulo={"lg-4"}
            obrigatorio
            grupo
            tituloBotao={this.state.tituloBotaoSenhaNova}
            iconeBotao={this.state.iconeBotaoSenhaNova}
            iconeBotaoDireita
            onBotaoClick={this.alternarSenhaVisivelNova}
          />

          <CampoTexto
            contexto={this}
            tipo={this.state.tipoInputSenhaConfirmar}
            nome={"confirmarSenha"}
            titulo={"Confirme nova senha"}
            valor={this.state.confirmarSenha}
            tamanhoTitulo={"lg-4"}
            obrigatorio
            grupo
            tituloBotao={this.state.tituloBotaoSenhaConfirmar}
            iconeBotao={this.state.iconeBotaoSenhaConfirmar}
            iconeBotaoDireita
            onBotaoClick={this.alternarSenhaVisivelConfirmar}
          />

          <Alerta
            ref={this.alert}
            padraoFormulario
            tipo={TipoAlerta.danger}
          />

          <Botao
            submit
            titulo={"Continuar"}
            tipo={TipoBotao.primary}
            block
            onClick={() => this.trocarSenha()}
            usaLoading
          />

        </Form>
      </PageClean>
    );
  }
}